<template>
  <head>
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />
  </head>

  <body @contextmenu.prevent data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">

    <NavigationBar/>

    <div id="content" class="content-minimize">
      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">Finance Act - Revenue Management System</h4>
                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a href="index.html">Dashboards</a></li>
                    <li class="breadcrumb-item active">Revenue Configuration</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Dashboard Statistics -->
          <div class="row mb-4">
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Total Departments</p>
                      <h4 class="mb-0">{{departments.length}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                                                <span class="avatar-title">
                                                    <i class="bx bx-building-house font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Revenue Streams</p>
                      <h4 class="mb-0">{{totalStreamsCount}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                                                <span class="avatar-title">
                                                    <i class="bx bx-dollar-circle font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">Active Fees</p>
                      <h4 class="mb-0">{{totalFeesCount}}</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                                                <span class="avatar-title">
                                                    <i class="bx bx-receipt font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="card mini-stats-wid">
                <div class="card-body">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <p class="text-muted fw-medium">SCoA Compliance</p>
                      <h4 class="mb-0">{{scoaComplianceRate}}%</h4>
                    </div>
                    <div class="flex-shrink-0 align-self-center">
                      <div class="mini-stat-icon avatar-sm rounded-circle bg-info">
                                                <span class="avatar-title">
                                                    <i class="bx bx-check-circle font-size-24"></i>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Search and Filter Bar -->
          <div class="row mb-3">
            <div class="col-12">
              <div class="card">
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label>Search across all revenue items</label>
                        <input
                            v-model="searchQuery"
                            type="text"
                            class="form-control"
                            placeholder="Search departments, streams, or fees..."
                            @input="performSearch"
                        >
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label>Filter by SCoA Category</label>
                        <select v-model="scoaFilter" class="form-control" @change="filterBySCoA">
                          <option value="">All Categories</option>
                          <option value="TAX">Tax Revenue</option>
                          <option value="NON-TAX">Non-Tax Revenue</option>
                          <option value="GRANTS">Grants & Transfers</option>
                          <option value="OTHER">Other Revenue</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label>Filter by Zone</label>
                        <select v-model="zoneFilter" class="form-control" @change="filterByZone">
                          <option value="">All Zones</option>
                          <option v-for="zone in zones" :key="zone.zone" :value="zone.zone">{{zone.zone}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>&nbsp;</label>
                        <button @click="exportToExcel" class="btn btn-success btn-block w-100">
                          <i class="mdi mdi-file-excel"></i> Export to Excel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Main Content Area -->
          <div class="row">
            <div class="col-4">
              <div class="card p-4">
                <div>
                  <div class="form-group">
                    <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                      <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                        <label>All Departments ({{departments.length}})<strong class="text-danger">*</strong></label>
                        <div v-if="getRight('CREATE DEPARTMENT')" class="d-flex">
                          <a @click="gotTo('department')" type="button" class="btn btn-primary dropdown-toggle option-selector" data-bs-toggle="offcanvas" data-bs-target="#dt__filter" aria-controls="offcanvasRight">
                            <i class="mdi mdi-account-multiple-plus-outline font-size-6"></i> <span class="pl-1 d-md-inline">Add Department</span>
                          </a>
                        </div>
                      </div>
                    </div>

                    <table class="table table-striped table-sm font-12 sources-table">
                      <thead>
                      <tr class="font-weight-bold text-black">
                        <th scope="col">No</th>
                        <th scope="col">Department</th>
                        <th scope="col">Streams</th>
                        <th scope="col">SCoA</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                          style="cursor: pointer;"
                          v-for="(item, index) in filteredDepartments"
                          :value="item"
                          :key="index"
                          @click="getIncomeTypes(item.departmentID)"
                          :class="{'table-active': selectedDepartmentId === item.departmentID}"
                      >
                        <td scope="row">{{index+1}}.</td>
                        <td>{{item.department}}</td>
                        <td><span class="badge bg-info">{{getDepartmentStreamCount(item.departmentID)}}</span></td>
                        <td>
                          <i v-if="item.scoaCompliant" class="mdi mdi-check-circle text-success"></i>
                          <i v-else class="mdi mdi-alert-circle text-warning" title="Incomplete SCoA mapping"></i>
                        </td>
                      </tr>
                      <tr style="background: #cee9d8;">
                        <th colspan="4"><strong>Total {{filteredDepartments.length}}</strong></th>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="card">
                <div class="calc-30px">
                  <div class="card">
                    <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                      <h7>Revenue streams
                        <button @click="getIncomeTypes('')" class="btn btn-warning btn-sm text-nowrap" title="View unmapped streams to department">
                          unmapped ({{unmappedStreamsCount}})
                        </button>
                      </h7>
                      <button @click="clearSelected" v-if="getRight('CREATE REVENUE STREAM')" class="btn btn-success btn-sm text-nowrap" title="Add New Revenue Stream" data-toggle="modal" data-target="#addRevenueStream">Add</button>
                    </div>

                    <div class="card-body">
                      <div class="table-responsive font-12">
                        <table class="table table-striped table-sm font-12 sources-table">
                          <thead>
                          <tr class="font-weight-bold text-black">
                            <th scope="col">No</th>
                            <th scope="col">Revenue streams</th>
                            <th scope="col">SCoA Code</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr
                              style="cursor: pointer;"
                              v-for="(item, index) in filteredIncomeTypes"
                              :value="item"
                              :key="index"
                              :class="{'table-active': selectedStreamId === item.incomeTypeId}"
                          >
                            <td scope="row">{{index+1}}</td>
                            <td scope="row" @click="getFeesAndCharges(item.incomeTypeId,item.incomeTypeDescription,item.accountDesc)">
                              <strong>{{item.brimsCode}}</strong> {{item.incomeTypeDescription}}
                              <small><b>{{item.zoneCategory}}</b></small>
                              <div v-if="item.scoaSegments" class="small text-muted">
                                {{item.scoaSegments.economic}} | {{item.scoaSegments.functional}}
                              </div>
                            </td>
                            <td>
                              <code class="small">{{item.fullScoaCode || 'N/A'}}</code>
                            </td>
                            <td v-if="getRight('EDIT REVENUE STREAM')">
                              <button @click="selectStream(item)" class="btn btn-success btn-sm text-nowrap" title="change department" data-toggle="modal" data-target="#changeStream">Edit</button>
                            </td>
                            <td v-if="getRight('DELETE REVENUE STREAM')">
                              <button @click="deleteStream(item)" class="btn btn-danger btn-sm text-nowrap" title="change department">Delete</button>
                            </td>
                          </tr>
                          <tr style="background: #cee9d8;">
                            <th colspan="5"><strong>Total {{filteredIncomeTypes.length}}</strong></th>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="card">
                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <h6 class="mb-0">Fees and charges</h6>
                    <div>
                      <button v-if="selectedStreamId" @click="duplicateFeeStructure" class="btn btn-info btn-sm text-nowrap me-2" title="Duplicate Fee Structure">
                        <i class="mdi mdi-content-copy"></i> Duplicate
                      </button>
                      <button @click="clearSelected" v-if="getRight('CREATE REVENUE STREAM')" class="btn btn-success btn-sm text-nowrap" title="Add New Fee and charges" data-toggle="modal" data-target="#addFeeAndCharge">Add</button>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div v-if="incomeTypeDescription" class="alert alert-info py-2 mb-3">
                    <strong>Stream:</strong> {{incomeTypeDescription}}
                  </div>

                  <table class="table table-striped table-sm font-12 sources-table">
                    <thead>
                    <tr class="font-weight-bold text-black">
                      <th scope="col">No</th>
                      <th scope="col">Description</th>
                      <th scope="col">Amount (KES)</th>
                      <th scope="col">Zone</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style="cursor: pointer;" v-for="(item, index) in filteredFeesAndCharges" :value="item" :key="index">
                      <td>{{index+1}}</td>
                      <td scope="row">
                        <strong>{{item.brimsCode}}</strong> {{item.feeDescription}}
                        <div v-if="item.validationErrors && item.validationErrors.length > 0" class="small text-danger">
                          <i class="mdi mdi-alert"></i> {{item.validationErrors.join(', ')}}
                        </div>
                      </td>
                      <td><b>{{formatCurrency(item.unitFeeAmount)}}</b></td>
                      <td><small><b>{{item.zone}}</b></small></td>
                      <td v-if="getRight('EDIT REVENUE STREAM')">
                        <button @click="selectFeeAndCharge(item)" class="btn btn-success btn-sm text-nowrap" title="Edit Fees and Charges" data-toggle="modal" data-target="#updateFeeAndCharge">Edit</button>
                      </td>
                      <td v-if="getRight('DELETE REVENUE STREAM')">
                        <button @click="deleteFeeAndCharge(item)" class="btn btn-danger btn-sm text-nowrap" title="Delete Fees and Charges">Delete</button>
                      </td>
                    </tr>
                    <tr style="background: #cee9d8;">
                      <th><strong>Total {{filteredFeesAndCharges.length}}</strong></th>
                      <th colspan="5"></th>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <!-- SCoA Compliance Report Section -->
          <div class="row mt-4">
            <div class="col-12">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title mb-0">SCoA Compliance Overview</h5>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-6">
                      <h6>Revenue Classification Summary</h6>
                      <div class="table-responsive">
                        <table class="table table-sm">
                          <thead>
                          <tr>
                            <th>SCoA Category</th>
                            <th>Count</th>
                            <th>Percentage</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="category in scoaCategories" :key="category.name">
                            <td>{{category.name}}</td>
                            <td>{{category.count}}</td>
                            <td>{{category.percentage}}%</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <h6>Validation Issues</h6>
                      <div v-if="validationIssues.length === 0" class="alert alert-success">
                        <i class="mdi mdi-check-circle"></i> All revenue items are SCoA compliant!
                      </div>
                      <div v-else class="alert alert-warning">
                        <i class="mdi mdi-alert-circle"></i> {{validationIssues.length}} items need attention
                        <ul class="mt-2 mb-0">
                          <li v-for="(issue, index) in validationIssues.slice(0, 5)" :key="index">
                            {{issue}}
                          </li>
                        </ul>
                        <small v-if="validationIssues.length > 5">...and {{validationIssues.length - 5}} more</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Enhanced Modal for changing revenue stream -->
      <div class="modal fade" id="changeStream" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Update Revenue Stream: {{incomeType.incomeTypeDescription}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" data-bs-toggle="tab" href="#basic-info" role="tab">
                    <span>Basic Information</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#scoa-mapping" role="tab">
                    <span>SCoA Mapping</span>
                  </a>
                </li>
              </ul>

              <div class="tab-content p-3">
                <div class="tab-pane active" id="basic-info" role="tabpanel">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="form-label">Revenue Department<strong class="text-danger">*</strong></label>
                        <select v-model="departmentID" class="form-control bg-white" title="Select Revenue Stream" data-live-search="true">
                          <option value="">Select Department</option>
                          <option v-for="(item, index) in departments" :key="`${index}`" :value="item.departmentID">{{item.department}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Revenue Type<strong class="text-danger">*</strong></label>
                        <select v-model="incomeTypePrefix" class="form-control bg-white" title="Select Revenue Stream" data-live-search="true">
                          <option value="">Select Revenue Type</option>
                          <option v-for="(item, index) in streams" :key="`${index}`" :value="JSON.stringify(item)">{{item.stream}}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label>Revenue Stream Description<strong class="text-danger">*</strong></label>
                        <input v-model="incomeType.incomeTypeDescription" type="text" class="form-control" placeholder="Revenue Stream">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>BRIMS Code<strong class="text-danger">*</strong></label>
                        <input v-model="incomeType.brimsCode" type="text" class="form-control" placeholder="Brims Code">
                        <small class="text-muted">Format: XXXX-XXXX-XXXX</small>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Available on USSD</label>
                        <div class="form-check form-switch">
                          <input v-model="ussd" class="form-check-input" type="checkbox" id="ussdSwitch">
                          <label class="form-check-label" for="ussdSwitch">
                            Enable for USSD menu
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-pane" id="scoa-mapping" role="tabpanel">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Economic Segment<strong class="text-danger">*</strong></label>
                        <select v-model="scoaMapping.economic" class="form-control" @change="updateScoaCode">
                          <option value="">Select Economic Classification</option>
                          <option value="1000">1000 - Tax Revenue</option>
                          <option value="1100">1100 - Property Tax</option>
                          <option value="1200">1200 - Business Permits</option>
                          <option value="2000">2000 - Non-Tax Revenue</option>
                          <option value="2100">2100 - Fees and Charges</option>
                          <option value="2200">2200 - Fines and Penalties</option>
                          <option value="3000">3000 - Grants and Transfers</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Functional Segment<strong class="text-danger">*</strong></label>
                        <select v-model="scoaMapping.functional" class="form-control" @change="updateScoaCode">
                          <option value="">Select Functional Classification</option>
                          <option value="701">701 - General Public Services</option>
                          <option value="702">702 - Public Order and Safety</option>
                          <option value="703">703 - Economic Affairs</option>
                          <option value="704">704 - Environmental Protection</option>
                          <option value="705">705 - Housing and Community</option>
                          <option value="706">706 - Health</option>
                          <option value="707">707 - Recreation and Culture</option>
                          <option value="708">708 - Education</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Fund Segment</label>
                        <select v-model="scoaMapping.fund" class="form-control" @change="updateScoaCode">
                          <option value="01">01 - General Fund</option>
                          <option value="02">02 - Special Revenue Fund</option>
                          <option value="03">03 - Capital Projects Fund</option>
                          <option value="04">04 - Debt Service Fund</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Geographic Segment</label>
                        <select v-model="scoaMapping.geographic" class="form-control" @change="updateScoaCode">
                          <option value="">County-wide</option>
                          <option v-for="zone in zones" :key="zone.zone" :value="zone.code">
                            {{zone.zone}}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-12">
                      <div class="alert alert-info">
                        <strong>Generated SCoA Code:</strong>
                        <code class="h5">{{generatedScoaCode || 'Complete all required fields'}}</code>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="message!==null" class="alert alert-danger mx-3" role="alert">
              {{message}}
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button @click="validateAndUpdateRevenueStream()" type="button" class="btn btn-primary">
                <i class="mdi mdi-check"></i> Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Enhanced Modal for updating fees and charges -->
      <div class="modal fade" id="updateFeeAndCharge" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Update Fees and Charges</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Fee Description<strong class="text-danger">*</strong></label>
                    <input v-model="feesAndCharge.feeDescription" type="text" class="form-control" placeholder="Fee Description">
                  </div>

                  <div class="form-group mt-3">
                    <label>Unit Fee Amount<strong class="text-danger">*</strong></label>
                    <div class="input-group">
                      <span class="input-group-text">KES</span>
                      <input v-model="feesAndCharge.unitFeeAmount" type="number" class="form-control" placeholder="Enter Amount">
                    </div>
                  </div>

                  <div class="form-group mt-3">
                    <label>Zone/Collection Points/Sub County<strong class="text-danger">*</strong></label>
                    <select class="form-select" v-model="feesAndCharge.zone" multiple>
                      <option value="ALL SUB COUNTIES">ALL SUB COUNTIES</option>
                      <option value="OTHER SUB COUNTIES">OTHER SUB COUNTIES</option>
                      <option v-for="(item, index) in zones" :key="index" :value="item.zone">
                        {{ item.zone }}
                      </option>
                    </select>
                    <small class="text-muted">Select zone or Sub County where the services apply</small>
                  </div>

                  <div class="form-group mt-3">
                    <label>BRIMS Code<strong class="text-danger">*</strong></label>
                    <input v-model="feesAndCharge.brimsCode" type="text" class="form-control" placeholder="Brims Code">
                  </div>

                  <div class="form-group mt-3">
                    <label>Effective Date</label>
                    <input v-model="feesAndCharge.effectiveDate" type="date" class="form-control">
                  </div>
                </div>
              </div>
            </div>
            <div v-if="message!==null" class="alert alert-danger" role="alert">
              {{message}}
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button @click="updateFeesAndCharge()" type="button" class="btn btn-primary">
                <i class="mdi mdi-check"></i> Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Enhanced Modal for adding fees and charges -->
      <div class="modal fade" id="addFeeAndCharge" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add New Fee/Charge for: {{feesAndCharge.typeDescription}}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="alert alert-info py-2">
                <i class="mdi mdi-information"></i> Create new fee structure for the selected revenue stream
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <div class="form-group">
                    <label>Fee Description<strong class="text-danger">*</strong></label>
                    <input v-model="feesAndCharge.feeDescription" type="text" class="form-control" placeholder="Fee Description">
                  </div>

                  <div class="form-group mt-3">
                    <label>Unit Fee Amount<strong class="text-danger">*</strong></label>
                    <div class="input-group">
                      <span class="input-group-text">KES</span>
                      <input v-model="feesAndCharge.unitFeeAmount" type="number" class="form-control" placeholder="Enter Amount">
                    </div>
                  </div>

                  <div class="form-group mt-3">
                    <label>Zone/Collection Points/Sub County<strong class="text-danger">*</strong></label>
                    <select class="form-select" v-model="feesAndCharge.zone" multiple>
                      <option value="ALL SUB COUNTIES">ALL SUB COUNTIES</option>
                      <option value="OTHER SUB COUNTIES">OTHER SUB COUNTIES</option>
                      <option v-for="(item, index) in zones" :key="index" :value="item.zone">
                        {{ item.zone }}
                      </option>
                    </select>
                    <small class="text-muted">Select zone or Sub County where the services apply</small>
                  </div>

                  <div class="form-group mt-3">
                    <label>BRIMS Code<strong class="text-danger">*</strong></label>
                    <div class="input-group">
                      <input v-model="feesAndCharge.brimsCode" type="text" class="form-control" placeholder="Auto-generated or enter manually">
                      <button @click="generateBrimsCode" class="btn btn-outline-secondary" type="button">
                        <i class="mdi mdi-refresh"></i> Generate
                      </button>
                    </div>
                  </div>

                  <div class="form-group mt-3">
                    <label>Unit of Measure</label>
                    <select v-model="feesAndCharge.unitOfMeasure" class="form-control">
                      <option value="Per Unit">Per Unit</option>
                      <option value="Per Day">Per Day</option>
                      <option value="Per Month">Per Month</option>
                      <option value="Per Year">Per Year</option>
                      <option value="Per Trip">Per Trip</option>
                      <option value="Per Transaction">Per Transaction</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="message!==null" class="alert alert-danger" role="alert">
              {{message}}
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button @click="addNewFeeAndCharge()" type="button" class="btn btn-primary">
                <i class="mdi mdi-check"></i> Save Fee Structure
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Enhanced Modal for adding revenue stream -->
      <div class="modal fade" id="addRevenueStream" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Create New Revenue Stream</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body">
              <div class="alert alert-info py-2">
                <i class="mdi mdi-information"></i> Complete all fields to ensure SCoA compliance
              </div>

              <ul class="nav nav-tabs" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" data-bs-toggle="tab" href="#new-basic-info" role="tab">
                    <span>Basic Information</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" href="#new-scoa-mapping" role="tab">
                    <span>SCoA Mapping</span>
                  </a>
                </li>
              </ul>

              <div class="tab-content p-3">
                <div class="tab-pane active" id="new-basic-info" role="tabpanel">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="form-label">Revenue Department<strong class="text-danger">*</strong></label>
                        <select class="form-control bg-white" @change="handleChange">
                          <option value="">Select Department</option>
                          <option v-for="(item, index) in departments" :key="`${index}`" :value="item.departmentID">{{item.department}}</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Revenue Type<strong class="text-danger">*</strong></label>
                        <select v-model="incomeTypePrefix" class="form-control bg-white">
                          <option value="">Select Revenue Type</option>
                          <option v-for="(item, index) in streams" :key="`${index}`" :value="JSON.stringify(item)">{{item.stream}}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label>Revenue Stream Description<strong class="text-danger">*</strong></label>
                        <input v-model="incomeTypeDescription" type="text" class="form-control" placeholder="Revenue Stream Description">
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>BRIMS Code<strong class="text-danger">*</strong></label>
                        <div class="input-group">
                          <input v-model="incomeType.brimsCode" type="text" class="form-control" placeholder="Auto-generated or enter manually">
                          <button @click="generateStreamBrimsCode" class="btn btn-outline-secondary" type="button">
                            <i class="mdi mdi-refresh"></i> Generate
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Available on USSD</label>
                        <div class="form-check form-switch">
                          <input v-model="ussd" class="form-check-input" type="checkbox" id="newUssdSwitch">
                          <label class="form-check-label" for="newUssdSwitch">
                            Enable for USSD menu
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="tab-pane" id="new-scoa-mapping" role="tabpanel">
                  <!-- Same SCoA mapping fields as in the update modal -->
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Economic Segment<strong class="text-danger">*</strong></label>
                        <select v-model="newScoaMapping.economic" class="form-control" @change="updateNewScoaCode">
                          <option value="">Select Economic Classification</option>
                          <option value="1000">1000 - Tax Revenue</option>
                          <option value="1100">1100 - Property Tax</option>
                          <option value="1200">1200 - Business Permits</option>
                          <option value="2000">2000 - Non-Tax Revenue</option>
                          <option value="2100">2100 - Fees and Charges</option>
                          <option value="2200">2200 - Fines and Penalties</option>
                          <option value="3000">3000 - Grants and Transfers</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label>Functional Segment<strong class="text-danger">*</strong></label>
                        <select v-model="newScoaMapping.functional" class="form-control" @change="updateNewScoaCode">
                          <option value="">Select Functional Classification</option>
                          <option value="701">701 - General Public Services</option>
                          <option value="702">702 - Public Order and Safety</option>
                          <option value="703">703 - Economic Affairs</option>
                          <option value="704">704 - Environmental Protection</option>
                          <option value="705">705 - Housing and Community</option>
                          <option value="706">706 - Health</option>
                          <option value="707">707 - Recreation and Culture</option>
                          <option value="708">708 - Education</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-3">
                    <div class="col-12">
                      <div class="alert alert-info">
                        <strong>Generated SCoA Code:</strong>
                        <code class="h5">{{newGeneratedScoaCode || 'Complete all required fields'}}</code>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="message!==null" class="alert alert-danger mx-3" role="alert">
              {{message}}
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button @click="validateAndAddRevenueStream()" type="button" class="btn btn-primary">
                <i class="mdi mdi-check"></i> Create Revenue Stream
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              © Best Birdy - SCoA Compliant Revenue Management
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Version 2.0 - Enhanced with Government Chart of Accounts
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  </body>
</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation";
import router from "@/router";
import {authUrl, biller, execute, getRight} from "@/api";

export default {
  name: "FinanceAct",
  components: {NavigationBar},
  data() {
    return {
      // Original data properties
      ussd: false,
      permission: '',
      message: null,
      departmentID: '',
      incomeTypeId: '',
      departments: [],
      revenueStream: '',
      incomeTypeDescription: '',
      incomeTypePrefix: '',
      incomeType: {
        incomeTypeId: null,
        incomeTypeDescription: null,
        incomeTypePrefix: null,
        fundDescription: null,
        status: null,
        departmentID: null,
        zoneCategoryID: null,
        zoneCategory: null,
        onUssd: null,
        brimsCode: null,
      },
      incomeTypes: [],
      feesAndCharges: [],
      feesAndCharge: {
        feeId: "",
        feeDescription: "",
        unitOfMeasure: "Per Unit",
        unitFeeAmount: "",
        accountNo: "",
        incomeTypeId: "",
        feeType: "",
        accountDesc: "",
        costCenterNo: "",
        zone: [],
        typeDescription: "",
        brimsCode: "",
        effectiveDate: ""
      },
      zones: [],
      streams: [],

      // New enhanced properties
      searchQuery: '',
      scoaFilter: '',
      zoneFilter: '',
      selectedDepartmentId: '',
      selectedStreamId: '',
      totalStreamsCount: 0,
      totalFeesCount: 0,
      unmappedStreamsCount: 0,
      scoaComplianceRate: 85,

      // SCoA mapping properties
      scoaMapping: {
        economic: '',
        functional: '',
        fund: '01',
        geographic: '',
        program: ''
      },
      newScoaMapping: {
        economic: '',
        functional: '',
        fund: '01',
        geographic: '',
        program: ''
      },
      generatedScoaCode: '',
      newGeneratedScoaCode: '',

      // Validation and compliance
      validationIssues: [],
      scoaCategories: [
        { name: 'Tax Revenue', count: 0, percentage: 0 },
        { name: 'Non-Tax Revenue', count: 0, percentage: 0 },
        { name: 'Grants & Transfers', count: 0, percentage: 0 },
        { name: 'Other Revenue', count: 0, percentage: 0 }
      ],

      // Filtered data
      filteredDepartments: [],
      filteredIncomeTypes: [],
      filteredFeesAndCharges: []
    }
  },

  computed: {
    // Add computed properties for enhanced functionality
  },

  watch: {
    departments: {
      handler() {
        this.filteredDepartments = [...this.departments];
        this.calculateStatistics();
      },
      deep: true
    },
    incomeTypes: {
      handler() {
        this.filteredIncomeTypes = [...this.incomeTypes];
        this.calculateStatistics();
      },
      deep: true
    },
    feesAndCharges: {
      handler() {
        this.filteredFeesAndCharges = [...this.feesAndCharges];
      },
      deep: true
    }
  },

  mounted() {
    this.feesAndCharges.splice(0);
    this.departments.splice(0);
    this.getDepartment();
    this.getIncomeTypes("");
    this.getZones();
    this.getMainStreams();
    this.permission = sessionStorage.getItem("permission");
    this.menuAccess();

    // Initialize enhanced features
    this.initializeEnhancements();
  },

  methods: {
    // Keep all original methods
    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Finance Act");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then(() => {
            // alert(res.data.message);
          })
          .catch(() => {
            // alert(e.message);
          });
    },

    getRight(type) {
      return getRight(type);
    },

    gotTo(route) {
      router.push(route);
    },

    handleChange(event) {
      this.departmentID = event.target.value;
    },

    selectStream(item) {
      this.incomeType = item;
      this.selectedStreamId = item.incomeTypeId;
      this.getDepartment();
      // Load SCoA mapping if exists
      this.loadScoaMapping(item);
    },

    selectFeeAndCharge(item) {
      this.feesAndCharge = item;
    },

    clearSelected() {
      this.feesAndCharge.unitFeeAmount = "";
      this.feesAndCharge.feeDescription = "";
      this.feesAndCharge.zone = [];
      this.feesAndCharge.brimsCode = "";
    },

    // Original CRUD methods with enhancements
    deleteFeeAndCharge(item) {
      this.feesAndCharge = item;
      const isConfirmed = window.confirm("Are you sure you want to delete this fee and charge?");

      if (isConfirmed) {
        this.incomeType = item;
        const data = new FormData();
        data.append("function", "deleteFeeAndCharge");
        data.append("feesAndCharge", this.feesAndCharge.feeId);
        execute(data, biller)
            .then((res) => {
              if (res.data.success) {
                this.message = res.data.message;
                // Refresh the fees list
                this.getFeesAndCharges(this.feesAndCharge.incomeTypeId, this.feesAndCharge.typeDescription, this.feesAndCharge.accountDesc);
              } else {
                this.message = res.data.message;
              }
            })
            .catch((e) => {
              this.message = e.message;
            });
      }
    },

    deleteStream(item) {
      const isConfirmed = window.confirm("Are you sure you want to delete this stream?");

      if (isConfirmed) {
        this.incomeType = item;
        const data = new FormData();
        data.append("function", "deleteStream");
        data.append("incomeTypeId", this.incomeType.incomeTypeId);
        data.append("incomeTypeDescription", this.incomeType.incomeTypeDescription);
        data.append("sessionNames", sessionStorage.getItem("sessionNames"));
        data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
        execute(data, biller)
            .then((res) => {
              if (res.data.success) {
                this.message = res.data.message;
                alert(res.data.message);
                this.getIncomeTypes(this.departmentID);
              } else {
                alert(res.data.message);
                this.message = res.data.message;
              }
            })
            .catch((e) => {
              this.message = e.message;
            });
      }
    },

    updateRevenueStream() {
      this.message = null;
      if (this.departmentID === '') {
        this.message = 'Select department to change';
        return;
      }
      this.message = null;
      const data = new FormData();
      data.append("function", "updateRevenueStream");
      data.append("departmentID", this.departmentID);
      data.append("incomeTypeId", this.incomeType.incomeTypeId);
      data.append("incomeTypeDescription", this.incomeType.incomeTypeDescription);
      data.append("incomeTypePrefix", this.incomeTypePrefix);
      data.append("ussd", this.ussd);
      data.append("brimsCode", this.incomeType.brimsCode);
      // Add SCoA mapping
      data.append("scoaMapping", JSON.stringify(this.scoaMapping));
      data.append("fullScoaCode", this.generatedScoaCode);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.message = res.data.message;
              alert("Revenue stream updated successfully!");
              this.getIncomeTypes(this.departmentID);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    // Keep all original data fetching methods
    getDepartment() {
      this.message = null;
      const data = new FormData();
      data.append("function", "getDepartment");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.departments.splice(0);
              this.departments = res.data.data.departments;

              this.departments.forEach((value, index) => {
                if (this.incomeType.departmentID === value.departmentID) {
                  this.departmentID = this.departments[index].departmentID;
                }
              });
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getZones() {
      const data = new FormData();
      data.append("function", "getZones");
      execute(data, authUrl)
          .then((res) => {
            if (res.data.success) {
              this.zones = res.data.data.zones;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getMainStreams() {
      const data = new FormData();
      data.append("function", "getMainStreams");
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.streams.splice(0);
              this.streams = res.data.data.streams;
              this.streams.forEach((value, index) => {
                if (this.incomeType.incomeTypePrefix === value.incomeTypePrefix) {
                  this.incomeTypePrefix = this.streams[index].incomeTypePrefix;
                }
              });
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    updateFeesAndCharge() {
      this.message = null;
      const data = new FormData();
      data.append("function", "updateFeesAndCharge");
      data.append("feesAndCharge", JSON.stringify(this.feesAndCharge));
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              alert("Fee structure updated successfully!");
              this.getFeesAndCharges(this.feesAndCharge.incomeTypeId, this.feesAndCharge.typeDescription);
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    addNewFeeAndCharge() {
      this.message = null;
      const data = new FormData();
      data.append("function", "addNewFeeAndCharge");
      data.append("feesAndCharge", JSON.stringify(this.feesAndCharge));
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              alert("New fee structure added successfully!");
              this.getFeesAndCharges(this.feesAndCharge.incomeTypeId, this.feesAndCharge.typeDescription);
              this.clearSelected();
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    addNewRevenueStream() {
      if (this.departmentID === "" || this.incomeTypePrefix === "") {
        this.message = "Please select department and revenue type";
        alert("Please select department and revenue type");
        return;
      }
      this.message = null;
      const data = new FormData();
      data.append("function", "addNewRevenueStream");
      data.append("incomeTypeDescription", this.incomeTypeDescription);
      data.append("incomeTypePrefix", this.incomeTypePrefix);
      data.append("departmentID", this.departmentID);
      data.append("ussd", this.ussd);
      data.append("brimsCode", this.incomeType.brimsCode);
      // Add SCoA mapping
      data.append("scoaMapping", JSON.stringify(this.newScoaMapping));
      data.append("fullScoaCode", this.newGeneratedScoaCode);

      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              alert("New revenue stream created successfully!");
              this.getIncomeTypes(this.departmentID);
              this.clearNewStreamForm();
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getIncomeTypes(departmentID) {
      this.selectedDepartmentId = departmentID;
      this.incomeTypes.splice(0);
      const data = new FormData();
      data.append("function", "getIncomeTypes");
      data.append("departmentID", departmentID);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.incomeTypes = res.data.data.incomeTypes;
              this.calculateStatistics();
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    getFeesAndCharges(incomeTypeId, incomeTypeDescription, accountDesc) {
      this.message = null;
      this.selectedStreamId = incomeTypeId;
      this.feesAndCharge.incomeTypeId = incomeTypeId;
      this.feesAndCharge.typeDescription = incomeTypeDescription;
      this.feesAndCharge.accountDesc = accountDesc;

      this.incomeTypeDescription = incomeTypeDescription;
      this.feesAndCharges.splice(0);
      const data = new FormData();
      data.append("function", "getFeesAndCharges");
      data.append("incomeTypeId", incomeTypeId);
      execute(data, biller)
          .then((res) => {
            if (res.data.success) {
              this.feesAndCharges = res.data.data.feesAndCharges;
              this.calculateStatistics();
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.message = e.message;
          });
    },

    // New Enhanced Methods
    initializeEnhancements() {
      // Set today's date as default effective date
      const today = new Date().toISOString().split('T')[0];
      this.feesAndCharge.effectiveDate = today;

      // Initialize filtered arrays
      this.filteredDepartments = [...this.departments];
      this.filteredIncomeTypes = [...this.incomeTypes];
      this.filteredFeesAndCharges = [...this.feesAndCharges];
    },

    // Search and Filter Methods
    performSearch() {
      const query = this.searchQuery.toLowerCase();

      if (!query) {
        this.filteredDepartments = [...this.departments];
        this.filteredIncomeTypes = [...this.incomeTypes];
        this.filteredFeesAndCharges = [...this.feesAndCharges];
        return;
      }

      // Filter departments
      this.filteredDepartments = this.departments.filter(dept =>
          dept.department.toLowerCase().includes(query)
      );

      // Filter income types
      this.filteredIncomeTypes = this.incomeTypes.filter(stream =>
          stream.incomeTypeDescription.toLowerCase().includes(query) ||
          stream.brimsCode.toLowerCase().includes(query) ||
          (stream.zoneCategory && stream.zoneCategory.toLowerCase().includes(query))
      );

      // Filter fees
      this.filteredFeesAndCharges = this.feesAndCharges.filter(fee =>
          fee.feeDescription.toLowerCase().includes(query) ||
          fee.brimsCode.toLowerCase().includes(query) ||
          fee.zone.toLowerCase().includes(query)
      );
    },

    filterBySCoA() {
      if (!this.scoaFilter) {
        this.filteredIncomeTypes = [...this.incomeTypes];
        return;
      }

      this.filteredIncomeTypes = this.incomeTypes.filter(stream => {
        // Assuming SCoA category is stored or can be derived from incomeTypePrefix
        if (this.scoaFilter === 'TAX' && stream.incomeTypePrefix && stream.incomeTypePrefix.startsWith('1')) return true;
        if (this.scoaFilter === 'NON-TAX' && stream.incomeTypePrefix && stream.incomeTypePrefix.startsWith('2')) return true;
        if (this.scoaFilter === 'GRANTS' && stream.incomeTypePrefix && stream.incomeTypePrefix.startsWith('3')) return true;
        if (this.scoaFilter === 'OTHER' && stream.incomeTypePrefix && stream.incomeTypePrefix.startsWith('4')) return true;
        return false;
      });
    },

    filterByZone() {
      if (!this.zoneFilter) {
        this.filteredFeesAndCharges = [...this.feesAndCharges];
        return;
      }

      this.filteredFeesAndCharges = this.feesAndCharges.filter(fee =>
          fee.zone === this.zoneFilter || fee.zone === 'ALL SUB COUNTIES'
      );
    },

    // Statistics Calculation
    calculateStatistics() {
      // Total streams count
      this.totalStreamsCount = this.incomeTypes.length;

      // Total fees count
      this.totalFeesCount = this.feesAndCharges.length;

      // Unmapped streams count
      this.unmappedStreamsCount = this.incomeTypes.filter(stream => !stream.departmentID).length;

      // Calculate SCoA compliance rate
      this.calculateScoaCompliance();

      // Calculate category distribution
      this.calculateCategoryDistribution();
    },

    calculateScoaCompliance() {
      let compliantCount = 0;
      let totalCount = this.incomeTypes.length;

      this.incomeTypes.forEach(stream => {
        if (stream.fullScoaCode && stream.brimsCode) {
          compliantCount++;
        }
      });

      this.scoaComplianceRate = totalCount > 0 ? Math.round((compliantCount / totalCount) * 100) : 0;

      // Identify validation issues
      this.validationIssues = [];
      this.incomeTypes.forEach(stream => {
        if (!stream.brimsCode) {
          this.validationIssues.push(`${stream.incomeTypeDescription} - Missing BRIMS code`);
        }
        if (!stream.fullScoaCode) {
          this.validationIssues.push(`${stream.incomeTypeDescription} - Incomplete SCoA mapping`);
        }
      });
    },

    calculateCategoryDistribution() {
      // Reset counts
      this.scoaCategories.forEach(cat => {
        cat.count = 0;
      });

      // Count by category
      this.incomeTypes.forEach(stream => {
        if (stream.incomeTypePrefix) {
          if (stream.incomeTypePrefix.startsWith('1')) this.scoaCategories[0].count++;
          else if (stream.incomeTypePrefix.startsWith('2')) this.scoaCategories[1].count++;
          else if (stream.incomeTypePrefix.startsWith('3')) this.scoaCategories[2].count++;
          else this.scoaCategories[3].count++;
        }
      });

      // Calculate percentages
      const total = this.incomeTypes.length;
      this.scoaCategories.forEach(cat => {
        cat.percentage = total > 0 ? Math.round((cat.count / total) * 100) : 0;
      });
    },

    getDepartmentStreamCount(departmentId) {
      return this.incomeTypes.filter(stream => stream.departmentID === departmentId).length;
    },

    // SCoA Code Generation and Validation
    updateScoaCode() {
      if (this.scoaMapping.economic && this.scoaMapping.functional) {
        this.generatedScoaCode = `${this.scoaMapping.economic}-${this.scoaMapping.functional}-${this.scoaMapping.fund}-${this.scoaMapping.geographic || '00'}-${this.departmentID || '000'}`;
      } else {
        this.generatedScoaCode = '';
      }
    },

    updateNewScoaCode() {
      if (this.newScoaMapping.economic && this.newScoaMapping.functional) {
        this.newGeneratedScoaCode = `${this.newScoaMapping.economic}-${this.newScoaMapping.functional}-${this.newScoaMapping.fund}-${this.newScoaMapping.geographic || '00'}-${this.departmentID || '000'}`;
      } else {
        this.newGeneratedScoaCode = '';
      }
    },

    loadScoaMapping(stream) {
      // Load existing SCoA mapping if available
      if (stream.scoaSegments) {
        this.scoaMapping = { ...stream.scoaSegments };
      } else {
        // Reset to defaults
        this.scoaMapping = {
          economic: '',
          functional: '',
          fund: '01',
          geographic: '',
          program: ''
        };
      }
      this.updateScoaCode();
    },

    // BRIMS Code Generation
    generateBrimsCode() {
      // Generate BRIMS code based on selected parameters
      const prefix = this.feesAndCharge.incomeTypeId ? this.feesAndCharge.incomeTypeId.toString().padStart(4, '0') : '0000';
      const random = Math.floor(Math.random() * 9999).toString().padStart(4, '0');
      this.feesAndCharge.brimsCode = `${prefix}-${random}`;
    },

    generateStreamBrimsCode() {
      // Generate BRIMS code for revenue stream
      const deptCode = this.departmentID ? this.departmentID.toString().padStart(2, '0') : '00';
      const typeCode = this.incomeTypePrefix ? JSON.parse(this.incomeTypePrefix).id.toString().padStart(2, '0') : '00';
      const random = Math.floor(Math.random() * 9999).toString().padStart(4, '0');
      this.incomeType.brimsCode = `${deptCode}${typeCode}-${random}`;
    },

    // Validation Methods
    validateAndUpdateRevenueStream() {
      if (!this.validateScoaMapping()) {
        this.message = "Please complete all required SCoA mapping fields";
        return;
      }

      if (!this.validateBrimsCode(this.incomeType.brimsCode)) {
        this.message = "Invalid BRIMS code format. Use format: XXXX-XXXX-XXXX";
        return;
      }

      this.updateRevenueStream();
    },

    validateAndAddRevenueStream() {
      if (!this.departmentID || !this.incomeTypePrefix || !this.incomeTypeDescription) {
        this.message = "Please fill all required fields";
        return;
      }

      if (!this.validateScoaMapping(true)) {
        this.message = "Please complete all required SCoA mapping fields";
        return;
      }

      if (!this.validateBrimsCode(this.incomeType.brimsCode)) {
        this.message = "Invalid BRIMS code format. Use format: XXXX-XXXX-XXXX";
        return;
      }

      this.addNewRevenueStream();
    },

    validateScoaMapping(isNew = false) {
      const mapping = isNew ? this.newScoaMapping : this.scoaMapping;
      return mapping.economic && mapping.functional;
    },

    validateBrimsCode(code) {
      if (!code) return false;
      // Basic validation - can be enhanced based on actual BRIMS code format
      return /^[A-Z0-9]{2,4}-[A-Z0-9]{2,4}(-[A-Z0-9]{2,4})?$/.test(code);
    },

    // Utility Methods
    formatCurrency(amount) {
      return new Intl.NumberFormat('en-KE', {
        style: 'currency',
        currency: 'KES',
        minimumFractionDigits: 0
      }).format(amount || 0);
    },

    // Export functionality
    exportToExcel() {
      // Prepare data for export
      const exportData = {
        departments: this.departments,
        revenueStreams: this.incomeTypes,
        feesAndCharges: this.feesAndCharges,
        scoaCompliance: {
          rate: this.scoaComplianceRate,
          categories: this.scoaCategories,
          issues: this.validationIssues
        }
      };

      // In a real implementation, this would generate and download an Excel file
      console.log("Exporting data:", exportData);
      alert("Export functionality would generate an Excel file with all revenue configuration data and SCoA compliance report.");
    },

    // Duplicate fee structure
    duplicateFeeStructure() {
      if (this.feesAndCharges.length === 0) {
        alert("No fee structure to duplicate");
        return;
      }

      // Clone the first fee structure
      const templateFee = { ...this.feesAndCharges[0] };
      delete templateFee.feeId;
      templateFee.feeDescription = templateFee.feeDescription + " (Copy)";

      this.feesAndCharge = templateFee;
      // Open the add modal
      $('#addFeeAndCharge').modal('show');
    },

    clearNewStreamForm() {
      this.incomeTypeDescription = '';
      this.incomeTypePrefix = '';
      this.departmentID = '';
      this.ussd = false;
      this.incomeType.brimsCode = '';
      this.newScoaMapping = {
        economic: '',
        functional: '',
        fund: '01',
        geographic: '',
        program: ''
      };
      this.newGeneratedScoaCode = '';
    }
  }
}
</script>

<style scoped>
/* Enhanced styles for better UX */
.table-active {
  background-color: #e3f2fd !important;
}

.sources-table tbody tr:hover {
  background-color: #f5f5f5;
  transition: background-color 0.2s;
}

.mini-stats-wid {
  border-left: 3px solid transparent;
  transition: all 0.3s;
}

.mini-stats-wid:hover {
  border-left-color: var(--bs-primary);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
}

.nav-tabs .nav-link {
  color: #495057;
  border: 1px solid transparent;
}

.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}

.badge {
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}

code {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #e83e8c;
  background-color: #f8f9fa;
  border-radius: 0.25rem;
}

.form-check-input:checked {
  background-color: #28a745;
  border-color: #28a745;
}

.alert-info {
  background-color: #d1ecf1;
  border-color: #bee5eb;
  color: #0c5460;
}

/* Animation for statistics cards */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mini-stats-wid {
  animation: fadeInUp 0.5s ease-out;
}
</style>